import { NBSP } from '../../../common/constants/symbols';
import { UIHeading4 } from '@cian/ui-kit';
import { clickBuyerGarantLink } from '../../utils/tracking';
import { IApplicationContext } from '../../../common/types/applicationContext';

export const TOOLTIP = {
  title: 'Подводные камни',
  text: `Шумные соседи, незаконная перепланировка, текущая крыша, незакрытая ипотека и${NBSP}другие юридические и${NBSP}технические особенности жилья могут добавить проблем и${NBSP}на${NBSP}этапе оформления сделки, и${NBSP}даже${NBSP}после заселения в${NBSP}новую квартиру.`,
  additionalDesc: `Агент проверит всё${NBSP}это, чтобы${NBSP}квартира не${NBSP}принесла вам${NBSP}неприятных сюрпризов.`,
};

export const getHowItWorks = (context: IApplicationContext['custom']) => {
  return [
    {
      id: 1,
      title: 'Подберём для вас лучшего агента',
      description:
        'Найдём специалиста, который разберётся в запросе и учтёт ваши возможности. Поменяем риелтора, если не сработаетесь',
      imageClass: 'step-1',
    },
    {
      id: 2,
      title: 'Предложим разные варианты под ваш бюджет',
      description:
        'Агент изучит рынок вторички и новостроек, будет общаться с продавцами и регулярно присылать подходящие варианты',
      imageClass: 'step-2',
    },
    {
      id: 3,
      title: 'Поможем купить выгоднее',
      description:
        'Когда найдём подходящий вариант, проведём переговоры о цене. Наш агент знает рынок и найдёт возможность для торга',
      imageClass: 'step-3',
    },
    {
      id: 4,
      title: 'Проследим за безопасностью сделки',
      description:
        'Юрист проверит документы на объект, оценит возможные риски и подготовит подробный отчёт. Агент будет рядом во время оформления, чтобы всё прошло спокойно и без лишнего стресса.',
      link: (
        <a
          href="https://static.cdn-cian.ru/frontend/collections-assets/cpd/landing/report.pdf"
          target="_blank"
          rel="noreferrer"
          onClick={() => clickBuyerGarantLink(context, 'SafeDealReportExample')}
        >
          <UIHeading4 color="text-main-default">Посмотреть пример отчёта</UIHeading4>
        </a>
      ),
      imageClass: 'step-4',
    },
    {
      id: 5,
      title: 'Организуем защиту от финансовых потерь',
      description:
        'Качественная проверка минимизирует риски, но если все же случится спор — поможем отстоять ваши интересы в суде или возместим 100% стоимости в случае неблагоприятного исхода',
      link: (
        <a
          href="https://static.cdn-cian.ru/frontend/collections-assets/cpd/landing/sert.pdf"
          target="_blank"
          rel="noreferrer"
          onClick={() => clickBuyerGarantLink(context, 'SafeDealCertificateExample2')}
        >
          <UIHeading4 color="text-main-default">Посмотреть пример сертификата</UIHeading4>
        </a>
      ),
      imageClass: 'step-5',
    },
    {
      id: 6,
      title: 'Вы в надёжных руках',
      description:
        'Мошенники не пройдут: агент поможет оформить документы без ошибок и убедится в безопасности расчётов, а Циан будет за всем присматривать',
      imageClass: 'step-6',
    },
  ];
};
